import { SvgIcon } from '@mui/material';
import React from 'react';

const Projects = (props) => {
    return (
        <SvgIcon
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            {...props}
        >
            <path d="M17,17V3a2,2,0,0,0-2-2H9.24a3,3,0,0,0-2.12.88L2.88,6.12A3,3,0,0,0,2,8.24V17a2,2,0,0,0,2,2H15A2,2,0,0,0,17,17ZM4,9H9a1,1,0,0,0,1-1V3h5V17H4ZM19,5V19a2,2,0,0,1-2,2H6a2,2,0,0,0,2,2h9a4,4,0,0,0,4-4V7A2,2,0,0,0,19,5Z" />
        </SvgIcon>
    );
};

export default Projects;
